import '~/routes/index.scss';
import React from 'react';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import CenterPanel from './center_panel';
import { ContentLibraryProvider } from './providers/content_library_provider';
import RightPanel from './right_panel';
const ContentLibrary = () => {
    return (React.createElement("div", { className: 'main-content' },
        React.createElement("div", { className: 'main-content-panels' },
            React.createElement(CenterPanel, null),
            React.createElement(RightPanel, null))));
};
const ContentLibraryWrapper = () => {
    return (React.createElement(PermissionChecker, { isRoute: true, requiredAllPermissions: [Permissions.BROWSE_CONTENT_LIBRARY] },
        React.createElement(ContentLibraryProvider, null,
            React.createElement(ContentLibrary, null))));
};
export default ContentLibraryWrapper;
